import Icon from '../components/Icon'
import { tw } from './strings'

/** Shown instead of the app when this native build has been retired. */
export default function UpdateRequired() {
  return (
    <main className="w-update-required" role="alert">
      <span className="w-update-ic" aria-hidden="true"><Icon name="alert" size={34} /></span>
      <h1>{tw('w.update.title')}</h1>
      <p>{tw('w.update.body')}</p>
      <div className="w-update-actions">
        <a className="button w-update-primary" href="https://apps.apple.com/app/id6815302926">{tw('w.update.appStore')}</a>
        <a className="button" href="itms-beta://beta.itunes.apple.com/v1/app/6815302926">{tw('w.update.testFlight')}</a>
      </div>
    </main>
  )
}
